import React from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

import { PATHS, TERMINALS } from '../../../constants';
import { useUpdatePageGroups } from '../../../hooks';
import { SideBarPageGroups } from '../../../types/enums';
import { PageGroupProps, StyledControlledCollapse, StyledHazardIcon, StyledNavLink } from './GeneralPageGroup.styles';
import { TitleIconRow } from './TitleIconRow';

const RiskPageGroup = ({ isExpanded }: PageGroupProps) => {
  const { t } = useTranslation();
  const location = useLocation();
  const { openPageGroups, updateOpenPageGroups } = useUpdatePageGroups();

  const isRiskCollapseOpen = isExpanded && openPageGroups.includes(SideBarPageGroups.Risk);

  return (
    <StyledControlledCollapse
      title={
        <TitleIconRow
          icon={<StyledHazardIcon $isExpanded={location.pathname.includes(TERMINALS.ParentGroups.Risk)} />}
          title={t('riskAssessments.sideBarTitle')}
          $isExpanded={isExpanded}
          open={isRiskCollapseOpen}
          $isActive={location.pathname.includes(TERMINALS.ParentGroups.Risk) && isExpanded}
        />
      }
      onClick={() => updateOpenPageGroups(SideBarPageGroups.Risk)}
      open={isRiskCollapseOpen}
      $isExpanded={isExpanded}
      $isActive={location.pathname.includes(TERMINALS.ParentGroups.Risk) && isExpanded}
    >
      <StyledNavLink to={PATHS.Risk.RiskAssessments.ROOT}>{t('riskAssessments.title')}</StyledNavLink>
      <StyledNavLink to={PATHS.Risk.RiskRegistry.ROOT}>{t('riskRegistry.title')}</StyledNavLink>
      <StyledNavLink to={PATHS.Risk.VendorAssessments.ROOT}>{t('vendorRisks.title')}</StyledNavLink>
    </StyledControlledCollapse>
  );
};

export default RiskPageGroup;
